/** @format */

import api from "../interceptor";

const url = "/search";
const storeID = process.env.NEXT_PUBLIC_STORE_ID || 1;

export const SearchAPI = {
  searchAll: ({
    page = 1,
    limit = 5,
    searchText,
  }: {
    page?: number;
    limit?: number;
    searchText: string;
  }) => {
    return api({
      method: "GET",
      url: url,
      params: {
        storeId: Number(storeID),
        searchText,
        page,
        limit,
        type: "all",
      },
    });
  },
};
